import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 44px;\n  height: 44px;\n  border-radius: 100%;\n  background: white;\n  box-shadow: ", ";\n\n  &::after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: url(\"", "\") no-repeat center center;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import SettingsSVG from '../assets/icons/dark-cog.svg';
import { TouchableOpacity } from '../TouchableOpacity';
import styled from '../utils/styling/styled-components';
import { SETTINGS_BUTTON } from '../utils/testing/TestIDs';
var SettingsButton = styled(TouchableOpacity).attrs({
  'data-testid': SETTINGS_BUTTON
})(_templateObject(), function (props) {
  return props.theme.shadows.smMedium;
}, SettingsSVG);
export { SettingsButton };